import { useEffect, useState } from 'react';
import { IDashRegistrationLog, IListItem } from '@nkr/models/index';
import { Button, Col, ControlLabel, FormControl, FormGroup, Panel } from 'react-bootstrap';

interface IProps {
    data: IDashRegistrationLog,
    actionList: IListItem[],
    onSave: (actionTaken: number, comments: string) => void,
    onCancel: () => void
}

const LogEntry = (props: IProps) => {
    const [actionTaken, setActionTaken] = useState(0);
    const [comments, setComments] = useState('');

    useEffect(() => {
        if (props.data != null) {
            setActionTaken(props.data.actionTakenId);
            setComments(props.data.comments);
        }
    }, [props.data])

    const buttonLabel = props.data == null ? 'Add' : 'Update';

    return (
        <Panel bsStyle='primary'>
            <Panel.Heading>
                {props.data == null ? 'Add Log Entry' : 'Edit Log Entry'}
            </Panel.Heading>
            <Panel.Body>
                {props.data != null && (
                    <>
                        <FormGroup>
                            <Col xs={12} lg={3} componentClass={ControlLabel}>Created</Col>
                            <Col xs={12} lg={9}>
                                <div>{props.data.logDateTimeForDisplay}</div>
                            </Col>
                        </FormGroup>

                        <FormGroup>
                            <Col xs={12} lg={3} componentClass={ControlLabel}>Created By</Col>
                            <Col xs={12} lg={9}>
                                <div>{props.data.createdByFullName}</div>
                            </Col>
                        </FormGroup>

                        {props.data.updateDateTimeForDisplay != '' && (
                            <>
                                <FormGroup>
                                    <Col xs={12} lg={3} componentClass={ControlLabel}>Last Updated</Col>
                                    <Col xs={12} lg={9}>
                                        <div>{props.data.updateDateTimeForDisplay}</div>
                                    </Col>
                                </FormGroup>

                                <FormGroup>
                                    <Col xs={12} lg={3} componentClass={ControlLabel}>Last Updated By</Col>
                                    <Col xs={12} lg={9}>
                                        <div>{props.data.updatedByFullName}</div>
                                    </Col>
                                </FormGroup>
                            </>
                        )}
                    </>
                )}

                <FormGroup>
                    <Col xs={12} lg={3} componentClass={ControlLabel}>Action Taken</Col>
                    <Col xs={12} lg={9}>
                        <FormControl
                            componentClass='select'
                            value={actionTaken}
                            onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => setActionTaken(parseInt(e.currentTarget.value))}
                        >
                            <option value={0}>- Select Action -</option>
                            {props.actionList.map(item =>
                                <option value={item.id}>{item.description}</option>
                            )}
                        </FormControl>
                    </Col>
                </FormGroup>

                <FormGroup>
                    <Col xs={12} lg={3} componentClass={ControlLabel}>Comments</Col>
                    <Col xs={12} lg={9}>
                        <FormControl
                            componentClass='textarea'
                            rows={6}
                            style={{ resize: 'none' }}
                            value={comments}
                            onChange={(e: React.FormEvent<FormControl & HTMLTextAreaElement>) => setComments(e.currentTarget.value)}
                        />
                    </Col>
                </FormGroup>
            </Panel.Body>
            <Panel.Footer>
                <div className='text-right'>
                    <Button bsStyle='primary' style={{ marginRight: 5 }} onClick={() => props.onSave(actionTaken, comments)}>{buttonLabel}</Button>
                    <Button bsStyle='link' onClick={props.onCancel}>Cancel</Button>
                </div>
            </Panel.Footer>
        </Panel>
    );
}

export default LogEntry;